import Vue from 'vue';
import App from './App.vue';
// import Vant, { Toast } from 'vant';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
// import http from './http';
import apis from './http/api.js';
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import i18n from './i18n';
// import uView from "uview-ui";

import 'video.js/dist/video-js.css'
import VueCookies from 'vue-cookies'

// 全局挂载到 Vue 原型
// Vue.prototype.$toast = Toast

// Vue.prototype.common = common
// Vue.prototype.$http = http
Vue.prototype.$apis = apis
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);

import "@/style/pc/element-variables.scss";
import Element from "element-ui";
Vue.use(Element, { size: 'small' });

Vue.use(VueCookies)

//监听页面宽度变化
import eventListener from '@/common/eventListener.js'
eventListener.init()

//统一封装 路由跳转
import navigator from '@/common/navigator'
Vue.prototype.$nav = navigator

//统一封装 提示组件
import notify from '@/common/notify.js'
Vue.prototype.$notify = notify

new Vue({
	store,
	router,
	i18n,
	render: h => h(App),
}).$mount('#app')